module.exports = __webpack_public_path__ + "img/werther-en.dd4d39da.jpg";